/* Bridge the theme's computed price and variant:update event to native Afterpay. */
(() => {
  if (window.__tlcAfterpayVariantSync) return;
  window.__tlcAfterpayVariantSync = true;

  const nativeSelector = 'square-placement[data-platform="shopify-app-blocks"]';
  const marker = 'script[data-tlc-afterpay-variant-sync]';
  const sync = (section, source) => {
    if (!section?.querySelector(marker)) return;
    section.querySelectorAll(nativeSelector).forEach((placement) => {
      const rendered = source.getElementById(placement.id);
      // A nonexistent variant renders no native amount. Mirror that state without
      // changing Afterpay eligibility or revealing anything hidden by the app.
      const container = placement.parentElement;
      const nativeAmount = rendered?.matches(nativeSelector) ? rendered.getAttribute('data-amount') : null;
      if (nativeAmount == null || nativeAmount.trim() === '') {
        if (!container.hidden) {
          container.hidden = true;
          container.dataset.tlcAfterpayUnavailable = 'true';
        }
        return;
      }
      if (container.dataset.tlcAfterpayUnavailable === 'true') {
        container.hidden = false;
        delete container.dataset.tlcAfterpayUnavailable;
      }
      const price = rendered.parentElement.previousElementSibling;
      const computed = price?.matches('product-price')
        ? price.querySelector('[data-tlc-afterpay-amount]')?.dataset.tlcAfterpayAmount
        : undefined;
      // The theme may move the response price children into the live DOM before
      // this document listener runs. Use only the matching adjacent live price.
      const livePrice = container.previousElementSibling;
      const liveComputed = livePrice?.matches('product-price')
        && livePrice.dataset.productId === price?.dataset.productId
        ? livePrice.querySelector('[data-tlc-afterpay-amount]')?.dataset.tlcAfterpayAmount
        : undefined;
      const amount = computed ?? liveComputed ?? nativeAmount;
      if (amount == null || amount.trim() === '' || !Number.isFinite(Number(amount)) || Number(amount) < 0) return;
      if (Number(placement.getAttribute('data-amount')) !== Number(amount)) {
        placement.setAttribute('data-amount', Number(amount).toFixed(2));
      }
    });
  };
  const initialize = () => {
    document.querySelectorAll(marker).forEach((script) => sync(script.closest('.shopify-section'), document));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('variant:update', (event) => {
    const picker = event.target;
    if (!(picker instanceof HTMLElement) || !picker.matches('variant-picker[data-template-product-match="true"]')) return;
    const html = event.detail?.data?.html;
    if (html?.getElementById) sync(picker.closest('.shopify-section'), html);
  });
})();
